<script lang="ts">
	import type { Device } from 'src/types/Device';
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import RadarDrawer from 'src/components/Radar/RadarDrawer.svelte';

	$: statusStore = getDeviceStatus(id);
	$: settingsStore = getDeviceSettings(id);
	export let device: Device;

	$: id = real_id(device?.id);
</script>

<SidepanelContent>
	<RadarDrawer {device} status={$statusStore} settings={$settingsStore} />
</SidepanelContent>
